export const OTP_LENGTH = 4;

export const CALENDAR_LINK = "https://cal.com/sanjith-takemytickets/15min?user=sanjith-takemytickets&overlayCalendar=true";